/*
 * @Date: 2022-09-19 15:50:07
 * @LastEditors: guantingting
 * @LastEditTime: 2022-09-19 16:59:55
 */
export default [
  {
    path: '/rent/v2/sms-page/vehicle-info',
    name: 'vehicleInfo',
    component: () => import('@/pages/smsPage/vehicleInfo'),
    meta: { title: '验车信息', requireAuth: true },
  },
]


// WEBPACK FOOTER //
// ./src/pages/smsPage/smsPage.js